<!--
create by melody on 2018/11/1
description:外币汇率查询页面
-->
<template>
	<div>
		<page-header :title="title"></page-header>
		<div class="hdp-uf hdp-uf-dc search-container">
			<div class="hdp-uf hdp-uf-hsb">
				<el-col style="width:30%;">
					<el-row :span="6" :offset="6">
						<div class="hdp-uf" style="width:100%;">
							<div class="hdp-uf hdp-uf-vc" style="width:30%;">{{$t('m.operatingUnit')}}：</div>
							<el-select filterable v-model="searchParam.operatingUnit" style="width:80%;" clearable>
								<el-option v-for="(item,index) in busEntityList" :key="index" :label="item.label" :value="item.label"></el-option>
							</el-select>
						</div>
					</el-row>
				</el-col>
				<el-col :gutter="10" style="width:30%;">
					<el-row :span="6" :offset="6">
						<div class="hdp-uf" style="width:100%;">
							<div class="hdp-uf hdp-uf-vc" style="width:30%;">{{$t('m.currencyFrom')}}：</div>
							<el-select filterable v-model="searchParam.currencyFrom" style="width:80%;" clearable>
								<el-option v-for="(item,index) in currencyList" :key="index" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</el-row>
					<el-row :span="6" :offset="6">
						<div class="hdp-uf" style="width:100%;">
							<div class="hdp-uf hdp-uf-vc" style="width:30%;">{{$t('m.currencyTo')}}：</div>
							<el-select filterable v-model="searchParam.currencyTo" style="width:80%;" clearable>
								<el-option v-for="(item,index) in currencyList" :key="index" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</el-row>
				</el-col>
				<el-col :gutter="10" style="width:30%;">
					<el-row :span="12" :offset="6">
						<div class="hdp-uf" style="width:100%;">
							<div class="hdp-uf hdp-uf-vc" style="width:30%;">{{$t('m.validityPeriodFrom')}}：</div>
							<el-date-picker
	                            style="width:70%;"
	                            v-model="searchParam.startDate"
	                            :picker-options="pickerOptions2"
	                            type="date"
	                            value-format="yyyy-MM-dd"
                                :placeholder="$t('m.chooseDate')">
	                        </el-date-picker>
						</div>
					</el-row>
					<el-row :span="6" :offset="6">
						<div class="hdp-uf" style="width:100%;">
							<div class="hdp-uf hdp-uf-vc" style="width:30%;">{{$t('m.validityPeriodTo')}}：</div>
							<el-date-picker
	                            style="width:70%;"
	                            v-model="searchParam.endDate"
	                            :picker-options="pickerOptions3"
	                            type="date"
	                            value-format="yyyy-MM-dd"
                                :placeholder="$t('m.chooseDate')">
	                        </el-date-picker>
						</div>
					</el-row>
				</el-col>
			</div>
			<div class="hdp-uf hdp-uf-hfe">
				<el-row>
                    <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
					<!-- <el-button type="primary" icon="el-icon-search" @click="getDemoList()"> 查 询 </el-button> -->
				</el-row>
			</div>
		</div>
		<div class="table-container">
			<el-button type="primary" icon="el-icon-plus" plain @click="handleClick('add')"> {{$t('m.add')}} </el-button>
			<el-button type="info" icon="el-icon-delete" plain @click="handleDelete('batch')"> {{$t('m.delete')}} </el-button>
			<el-table ref="multipleTable" :data="tableData" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0" @select="handleSelect" @select-all="handleSelectAll">
				<el-table-column type="selection" width="35"></el-table-column>
				<el-table-column type="index"></el-table-column>
				<el-table-column :label="$t('m.operatingUnit')" width="300" prop="operatingUnit"></el-table-column>
				<el-table-column :label="$t('m.currencyFrom')" prop="currencyFrom" width="150"></el-table-column>
				<el-table-column :label="$t('m.currencyTo')" prop="currencyTo"  width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="startDate" :label="$t('m.validityPeriodFrom')"  width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="endDate" :label="$t('m.validityPeriodTo')"  width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="exchangeRate" :label="$t('m.exchangeRate')"  width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="enableFlag" :label="$t('m.enableFlag')"  width="150">
                    <template slot-scope="scope">
                        <span>{{scope.row.enableFlag == true ? $t('m.enable') : $t('m.disable')}}</span>
                    </template>
                </el-table-column>
				<el-table-column :label="$t('m.operation')" align="right" width="150">
					<template slot-scope="scope">
						<el-button icon="el-icon-edit-outline" size='mini' plain @click="handleClick('modify', scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete('single', scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="hdp-uf">
                <a href="./static/template/外币汇率配置模板.xlsx">
                    <el-button type="primary" icon="el-icon-download"> {{$t('m.exchangeTemplate')}} </el-button>
                </a>
                <lap-upload-file uploadUrl="/config/exchangeRate/uploadedExchange" @successMethod="getDemoList()"></lap-upload-file>
			</div>
			<lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
		</div>
		<!-- add Form -->
		<el-dialog
			:title="operateType=='add'? $t('m.add') :operateType=='modify'? $t('m.modify') :''"
			:visible.sync="dialogVisible"
			v-if="dialogVisible"
			width="30%">
			<div style="margin-left: 10%">
				<el-form ref="form" :model="form" :rules="rules" label-width="150px">
					<el-form-item :label="$t('m.operatingUnit')" prop="operatingUnit">
						<el-select v-model="form.operatingUnit" style="width:80%;">
							<el-option v-for="(item,index) in busEntityList" :key="index" :label="item.label" :value="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('m.currencyFrom')" prop="currencyFrom">
						<el-select v-model="form.currencyFrom" style="width:80%;">
							<el-option v-for="(item,index) in currencyList" :key="index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('m.currencyTo')" prop="currencyTo">
						<el-select v-model="form.currencyTo" style="width:80%;">
							<el-option v-for="(item,index) in currencyList" :key="index" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('m.validityPeriodFrom')" prop="startDate">
						 <el-date-picker
                            style="width:80%;"
                            v-model="form.startDate"
                            :picker-options="pickerOptions0"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('m.chooseDate')">
                        </el-date-picker>
					</el-form-item>
					<el-form-item :label="$t('m.validityPeriodTo')" prop="endDate">
						<el-date-picker
                            style="width:80%;"
                            v-model="form.endDate"
                            :picker-options="pickerOptions1"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('m.chooseDate')">
                        </el-date-picker>
					</el-form-item>
					<el-form-item :label="$t('m.exchangeRate')" prop="exchangeRate">
						<el-input v-model.trim="form.exchangeRate" :maxlength="$inputLengthObj.maxLength2" style="width:80%;"></el-input>
					</el-form-item>
					<el-form-item :label="$t('m.enableFlag')" prop="enableFlag">
						<el-radio-group  v-model="form.enableFlag">
                            <el-radio :label="true" checked>{{$t('m.enable')}}</el-radio>
                            <el-radio :label="false">{{$t('m.disable')}}</el-radio>
                        </el-radio-group>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
				<el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
	data() {
		return {
			title: {
				firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.CONFIG_MANAGE'),
                thirdTitle: this.$t('m.EXCHANGE_RATE')
			},
			searchParam: {
				operatingUnit:'',
				currencyFrom:'',
				currencyTo:'',
				startDate:'',
				endDate:'',
				pageNum: 1,
				pageSize: 10
			},
			form: {     //弹框内容
                exchangeRateId: '',
                operatingUnit: '',
                currencyFrom: '',
                currencyTo: '',
                startDate: '',
                endDate: '',
                exchangeRate: '',
                enableFlag: true,
            },
            rules: this.$ruleApi.getRule('exchangeRate'),
             //开始日期：当前日期后和结束日期后不可勾选
            pickerOptions0: {
                disabledDate: (time) => {
                    if (this.form.endDate) {
                        var d = new Date(this.form.endDate);
                        return time.getTime() > d.getTime() 
                    }
                },
            },
            //结束日期：当前日期后和开始日期前不可勾选
            pickerOptions1: {
                disabledDate: (time) => {
                    if (this.form.startDate) {
                        var d = new Date(this.form.startDate);
                        return time.getTime() < d.getTime() - 86400000
                    }
                }
            },
             //开始日期：当前日期后和结束日期后不可勾选
            pickerOptions2: {
                disabledDate: (time) => {
                    if (this.searchParam.endDate) {
                        var d = new Date(this.searchParam.endDate);
                        return time.getTime() > d.getTime()
                    }
                },
            },
            //结束日期：当前日期后和开始日期前不可勾选
            pickerOptions3: {
                disabledDate: (time) => {
                    if (this.searchParam.startDate) {
                        var d = new Date(this.searchParam.startDate);
                        return time.getTime() < d.getTime() - 86400000
                    }
                }
            },
            tableData: [],  //表数据
            tableErrorData: [],
            total: 0,   //总数
            dialogVisible: false,   //控制弹框显示与隐藏
            uploadDialogVisible: false,
			uploadFileUrl:'',
			fileList: [],
			currentPage: 1,
			busEntityList: [],
			currencyList: [],
			operateType: '',    //操作类型 add新增 modify修改 view查看
			deleteDemoIdArr: [],
            addDisable: false
		}
	},
	computed: {
		...mapState({
			resDataObj: state => state.exchangeRate.mockData
		}),
		...mapGetters({
			resData: 'exchangeRate/getMockData'
		})
	},
	methods: {
		getDemoList() {
            this.$commonFunc.commonRequest('get', '/config/exchangeRate/list/condition', 'getExchangeRateList', this.searchParam)
            .then(res=>{
                this.tableData = res.obj.list
                this.total = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemo() {
            this.$commonFunc.commonRequest('post', '/config/exchangeRate/added', 'addExchangeRate', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemo() {
            this.$commonFunc.commonRequest('post', '/config/exchangeRate/modified', 'modifyExchangeRate', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
            this.operateType = type
            this.dialogVisible = true
            //如果操作已有数据
            if(row) {
            	this.form = JSON.parse(JSON.stringify(row))
            } else {
                this.form = {
	                operatingUnit: '',
                    currencyFrom: '',
                    currencyTo: '',
                    startDate: '',
                    endDate: '',
                    exchangeRate: '',
                    enableFlag: true,
                }
            }
        },
        //弹框保存操作
        haddleSave(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if(type=='add') {
                        this.addDisable = true
                        this.addDemo()
                    } else {
                        this.modifyDemo()
                    }
                } else {
                    return false;
                }
            });
        },
        handleDelete(type,row) {
        	if( type == 'batch' && this.deleteDemoIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                let demoIds = []
                if (type == 'single') {
                    demoIds.push(row.exchangeRateId)
                } else {
                	demoIds = this.deleteDemoIdArr
                }
                this.$commonFunc.commonRequest('get', '/config/exchangeRate/deleted', 'deleteExchangeRate', {exchangeRateIds: demoIds})
                .then(res=>{
                	this.$message.success(this.$t('m.deleteSuccess'))
                	this.deleteDemoIdArr = []
                	this.getDemoList()
                })
                .catch(res=>{
                	this.$message.error(res.message)
                })
            })
        },
		doUpLoadFile(){
			this.$commonFunc.commonRequest('upLoadFile', '/config/exchangeRate/uploadedExchange', 'uploadedFile', {uploadedFile: this.uploadedFile})
            .then(res=>{
                if(JSON.stringify(res.obj)=='{}') {
                    this.$message.success(this.$t('m.uploadSuccess'));
                    this.getDemoList()
                } else {
                    this.tableErrorData = []
                    for (var key in res.obj) {
                        this.tableErrorData.push({'order': key, 'description': res.obj[key]})
                    }
                    this.uploadDialogVisible = true
                }
            })
		},
		actionChange(param) {
            let res = this.$commonFunc.checkFileTypeAndSize(param)
            if(res) {
                this.$message.error(res)
                return
            }
          	this.uploadFileUrl = param.name
          	this.uploadedFile = param.raw
        },
		//处理单选
        handleSelect(row) {
            this.deleteDemoIdArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr.push(row[i].exchangeRateId)
                }
            }
        },
        //处理全选
        handleSelectAll(selection) {
            this.deleteDemoIdArr = []
            if(selection.length) {
                for(var i = 0; i < selection.length; i++) {
                    this.deleteDemoIdArr.push(selection[i].exchangeRateId)
                }
            }
        },
	},
	async mounted() {
		this.getDemoList()
		this.busEntityList = await this.$commonFunc.getValueSetList(this.$valueSetObj.BUSINESS_ENTITY)
		this.currencyList = await this.$commonFunc.getValueSetList(this.$valueSetObj.CURRENCY)
	}
}
</script>
<style scoped>
.search-container {
	background: #ffffff;
	padding: 20px 20px 0 20px;
}

.table-container {
	padding: 24px;
	margin: 32px 0;
	background: #ffffff;
}

.block {
	text-align: right;
}
.file-btn{
	margin-left:10px;
}


.el-row {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}
.el-col {
	border-radius: 4px;
}
.bg-purple-dark {
	background: #99a9bf;
}
.bg-purple {
	background: #d3dce6;
}
.bg-purple-light {
	background: #e5e9f2;
}
.grid-content {
	border-radius: 4px;
	min-height: 36px;
}
.row-bg {
	padding: 10px 0;
	background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/pages/config/ExchangeRate.vue